import { FC } from 'react'

import { Button, IconArrowUpRight, Link } from '@sequencehq/core-components'

export const ViewRecordAction: FC<{
  to: string
  label: string
  'data-testid'?: string
}> = ({ to, label, 'data-testid': dataTestId }) => (
  <Button
    as={Link.Unstyled}
    to={to}
    variant="secondary"
    leadingIcon={<IconArrowUpRight />}
    data-testid={dataTestId}
  >
    {label}
  </Button>
)
